import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContabilidadService } from '../../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

declare function init_plugins();

@Component({
  selector: 'app-creaoptioncontable',
  templateUrl: './creacuentacontable.component.html',
  styles: []
})
export class CreaCuentaContableComponent implements OnInit {

  forma: FormGroup;
  banks: any[] = [];
  constructor(
    private route: ActivatedRoute,
    public _contabilidad: ContabilidadService,
    public router: Router
  ) { }


  ngOnInit() {

    this._contabilidad.getPersonBank().subscribe( resp => {
      this.banks = resp.data.map( bank => { return bank.attributes });
    });
      this.forma = new FormGroup({
        account: new FormControl( null , Validators.required ),
        accounting_key: new FormControl( null , Validators.required ),
        accounting_name: new FormControl( null , Validators.required ),
        accounting_type: new FormControl( null),
        assigment: new FormControl( null),
        center: new FormControl( null ),
        cost_center: new FormControl( null ),
        definition: new FormControl( null),
        pep_element: new FormControl( null ),
        profit_center: new FormControl( null),
        tax_indicator: new FormControl( null),
        bank: new FormControl(null)
      } );

  }


  registrarOpcion() {

    this._contabilidad.crearCuentaContable(this.forma.value).subscribe( () => {
    Swal.fire({
      title: 'Creacion de cuenta exitosa',
      text: '',
      icon: 'success',
      showConfirmButton: true,
      showCancelButton: false,
      allowOutsideClick: false
    }). then ( res => {
      if ( res.value ) {
        this.router.navigate(['/contabilidad/cuentascontables']);
      }

    } );

  }, (err) => {             console.log(err);
                            Swal.fire(
                              'Error al crear Opcion',
                              'Error',
                              'error'
                           );
                        } ); 

  }


}
